import axiosInstance from "../../apiAxios/axiosInstance";

// Get all notifications
export const getNotifications = async (payload) => {
  const response = await axiosInstance.post("/vendor/all-notifications", payload);
  return response.data;
};
export const getDropdownNotifications = async (payload) => {
  const response = await axiosInstance.post("/vendor/notifications", payload);
  return response.data;
};

export const getUnreadCount = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/notifications/unread-count",
    payload
  );
  return response.data;
};

// Mark a single notification as read
export const markNotificationRead = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/notifications/mark-read",
    payload
  );
  return response.data;
};

// Mark all notifications as read
export const markAllNotificationsRead = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/notifications/mark-all-read",
    payload
  );
  return response.data;
};

// Delete a notification
export const deleteNotification = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/notifications/delete",
    payload
  );
  return response.data;
};